import { render, staticRenderFns } from "./sendmanWallet.vue?vue&type=template&id=aba6038a&scoped=true&"
import script from "./sendmanWallet.vue?vue&type=script&lang=js&"
export * from "./sendmanWallet.vue?vue&type=script&lang=js&"
import style0 from "./sendmanWallet.vue?vue&type=style&index=0&id=aba6038a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba6038a",
  null
  
)

export default component.exports